// extracted by mini-css-extract-plugin
export default {"userHistoryContainer":"UserHistory_userHistoryContainer__iyyBN","userHistoryTableContainer":"UserHistory_userHistoryTableContainer__vLBwm","maxWidth":"UserHistory_maxWidth__nIqAC"};